import { RangeDate, ToB, FromB } from "components/general/RangeDate";
import ButtonV2 from "components/individual/ButtonsV2/Button";
import useDialog from "customHooks/useDialog";
import React, { useCallback, useState } from "react";
import Dialog from "structure/Dialog";
import { getControlReport } from "helpers/Apis/Documents";
import { Spinner } from "components/individual/Spinner/Spinner";

export default function GlobalOperation({ children = <></> }) {
  const dialog = useDialog();

  // 📅 rango por defecto: año actual
  const currentYear = new Date().getFullYear();

  const [range, setRange] = useState({
    from: new Date(currentYear, 0, 1),
    to: new Date(currentYear, 11, 31),
  });

  const [loading, setLoading] = useState(false);

  // 🔁 handler para "Desde"
  const handleFromChange = useCallback((date) => {
    setRange((prev) => ({
      ...prev,
      from: date,
    }));
  }, []);

  // 🔁 handler para "Hasta"
  const handleToChange = useCallback((date) => {
    setRange((prev) => ({
      ...prev,
      to: date,
    }));
  }, []);

  // ⬇️ Descargar reporte
  const handleDownload = useCallback(async () => {
    if (loading) return;

    try {
      setLoading(true);

      const from = range.from.toISOString().split('T')['0']
      const to = range.to.toISOString().split('T')['0']

      await getControlReport(from, to);

      dialog.close();
    } catch (error) {
      console.error("Error downloading control report:", error);
    } finally {
      setLoading(false);
    }
  }, [range, dialog, loading]);

  return (
    <>
      <div onClick={() => dialog.open()}>{children}</div>

      <Dialog
        width={30}
        closeCallback={() => dialog.close()}
        forwardRef={dialog.refDialog}
        footer={
          <ButtonV2
            style={{ width: "100%" }}
            onClick={handleDownload}
            disabled={loading}
          >
            {loading ? "Descargando " : "Descargar "}
          </ButtonV2>
        }
        title="Operación Global"
      >
        <div style={{ minHeight: "40svh" }}>
          <RangeDate>
            <div style={{ display: "flex", gap: "10px" }}>
              <FromB defaultValue={range.from} onChange={handleFromChange} />
              <ToB defaultValue={range.to} onChange={handleToChange} />
            </div>
          </RangeDate>

          <p className="text-center mt-2">
            Rango de fechas filtra por la creación del pedido asociada a la
            factura timbrada
          </p>
        </div>
      </Dialog>
    </>
  );
}
